import { render, staticRenderFns } from "./BasicRating.vue?vue&type=template&id=a9fc478a"
import script from "./BasicRating.vue?vue&type=script&lang=js"
export * from "./BasicRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports